// import {} '../actions/actionList'

export const loginInitialState = {
  login: {
    studentid: null,
    schoolid: null,
    classid: null,
    firstname: null,
    lastname: null,
    current_module: null,
    influencerid: null,
    influencerid1: null,
    influencerid2: null,
    influencerid3: null,
    influencerid4: null,
    cookie: null,
    expiration: 0,
    cloudFront: (!window.location.href.includes('wearefriends.cool')) ?  'https://staging-web.wearefriends.cool/' : window.location.href.includes('staging') ? 'https://staging-web.wearefriends.cool/' : 'https://wearefriends.cool/',
    endPoint: null,
    s3Bucket: null,
    grade: null,
    receivedCoin: null
  },
};

const loginReducer = (state = loginInitialState, action) => {
  switch (action.type) {
    case 'CLEAR': {
      return {
        ...loginInitialState,
      };
    }
    case 'SET_ID': {
      return {
        ...state,
        login: {
          ...state.login,
          studentid: action.payload,
        },
      };
    }
    case 'SET_SCHOOLID': {
      return {
        ...state,
        login: {
          ...state.login,
          schoolid: action.payload,
        },
      };
    }
    case 'SET_CLASSID': {
      return {
        ...state,
        login: {
          ...state.login,
          classid: action.payload,
        },
      };
    }
    case 'SET_FIRSTNAME': {
      return {
        ...state,
        login: {
          ...state.login,
          firstname: action.payload,
        },
      };
    }
    case 'SET_LASTNAME': {
      return {
        ...state,
        login: {
          ...state.login,
          lastname: action.payload,
        },
      };
    }
    case 'SET_MODULE': {
      return {
        ...state,
        login: {
          ...state.login,
          current_module: action.payload,
        },
      };
    }
    case 'SET_INFLUENCER1ID': {
      return {
        ...state,
        login: {
          ...state.login,
          influencerid: action.payload,
        },
      };
    }
    case 'SET_INFLUENCER2ID': {
      return {
        ...state,
        login: {
          ...state.login,
          influencerid1: action.payload,
        },
      };
    }
    case 'SET_INFLUENCER3ID': {
      return {
        ...state,
        login: {
          ...state.login,
          influencerid2: action.payload,
        },
      };
    }
    case 'SET_INFLUENCER4ID': {
      return {
        ...state,
        login: {
          ...state.login,
          influencerid3: action.payload,
        },
      };
    }
    case 'SET_INFLUENCER5ID': {
      return {
        ...state,
        login: {
          ...state.login,
          influencerid4: action.payload,
        },
      };
    }
    case 'SET_COOKIE': {
      return {
        ...state,
        login: {
          ...state.login,
          cookie: action.payload,
        },
      };
    }
    case 'SET_EXPIRATION': {
      return {
        ...state,
        login: {
          ...state.login,
          expiration: action.payload,
        },
      };
    }
    case 'SET_ENDPOINT': {
      return {
        ...state,
        login: {
          ...state.login,
          endPoint: action.payload,
        },
      };
      
    }
    case 'SET_S3BUCKET': {
      return {
        ...state,
        login: {
          ...state.login,
          s3Bucket: action.payload,
        },
      };
    }

    case 'SET_GRADE': {
      return {
        ...state,
        login: {
          ...state.login,
          grade: action.payload,
        },
      };
    }
    case 'SET_RECEIVEDCOIN': {
      return {
        ...state,
        login: {
          ...state.login,
          receivedCoin: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
export default loginReducer;
